module.exports = __webpack_public_path__ + "static/media/10.Stage Setup final.05d37ba2.JPG";